import _ from 'lodash';
import React, { PureComponent } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import SplitBillPagesContainer from "../../containers/billing/SplitBillPage";

class FMPSplitBillPagesSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const {splitBillPages, searchSplitBillPages} = this.props;
		if (!splitBillPages) {
			searchSplitBillPages({
				params : {}
			});
		}
	}

	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, readOnly,
			splitBillPages,
		} = this.props;

		const hasError = !!error;
		const _onChange = event => {
			onChange(event.target.value, path);
		};

		if (!splitBillPages) {
			return (<Grid spacing={2} container>
				<Grid item xs={12} md={md}>
					<FormControl fullWidth={true} error={hasError}>
						<InputLabel htmlFor={path}>{label}</InputLabel>
						<Select
							value={value}
							input={<Input id={path} readOnly={readOnly} />}
						>
							<MenuItem key={'loading_splitBillPage'} value={'loading'} disabled>
								Loading split bill pages...
							</MenuItem>
						</Select>
					</FormControl>
				</Grid>
			</Grid>);
		}

		return (<Grid spacing={2} container>
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{_.sortBy(splitBillPages, 'billName', 'pageNumber').map(splitBillPage => {
							const { splitBillPageId, billName, pageNumber, dateCreated} = splitBillPage;

							const displayDate = (<span style={{paddingLeft : 8, fontSize : '90%', color : '#888'}}>
								({moment(dateCreated).format('M/D h:mm a')})
							</span>);
							return (
								<MenuItem key={splitBillPageId} value={splitBillPageId}>
									{billName} - Page #{pageNumber} {displayDate}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

FMPSplitBillPagesSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	splitBillPages : PropTypes.array,
	searchSplitBillPages : PropTypes.func.isRequired,

	md : PropTypes.number,
	helpText : PropTypes.string,
	readOnly : PropTypes.bool,
};


FMPSplitBillPagesSelect.defaultProps =  {
	label : 'Bulk Customer',
	readOnly : false,
	md : 12
};

export default _.flow([
	SplitBillPagesContainer,
])(FMPSplitBillPagesSelect);
